export default [
  {
    id: 'electronic-music',
    label: 'Electronic',
    name: 'electronic-music',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_g_electronic.png',
    link: '?genres=electronic-music',
  },
  {
    id: 'beats',
    label: 'Beats',
    name: 'beats',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_beats.png',
    link: '?genres=beats',
  },
  {
    id: 'hip-hop-and-trap',
    label: 'Hip Hop & Trap',
    name: 'hip-hop-and-trap',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_hiphop.png',
    link: '?genres=hip-hop-and-trap',
  },
  {
    id: 'ambient',
    label: 'Ambient',
    name: 'ambient',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_ambient.png',
    link: '?genres=ambient',
  },
  {
    id: 'pop',
    label: 'Pop',
    name: 'pop',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_pop.png',
    link: '?genres=pop',
  },
  {
    id: 'latin',
    label: 'Latin',
    name: 'latin',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_latin.png',
    link: '?genres=latin',
  },
  {
    id: 'lo-fi',
    label: 'LoFi',
    name: 'lo-fi-',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_lofi.png',
    link: '?genres=lo-fi-',
  },
  {
    id: 'cinematic',
    label: 'Cinematic',
    name: 'cinematic',
    image:
      'https://www.loudly.com/wp-content/uploads/2021/01/md_g_cinematic.png',
    link: '?genres=cinematic',
  },
  {
    id: 'funk',
    label: 'Funk',
    name: 'funk',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_funk.png',
    link: '?genres=funk',
  },
  {
    id: 'world',
    label: 'World Music',
    name: 'world',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_world.png',
    link: '?genres=world',
  },
  {
    id: 'rock',
    label: 'Rock',
    name: 'rock',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_rock.png',
    link: '?genres=rock',
  },
  {
    id: 'house',
    label: 'House',
    name: 'house',
    image: 'https://www.loudly.com/wp-content/uploads/2021/01/md_g_house.png',
    link: '?genres=house',
  },
];
